import { Dialog, DialogContent } from "common/components/ui/Dialog";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuList,
  DropdownMenuTrigger,
} from "common/components/ui/DropdownMenu";
import { typedObjectEntries } from "common/helpers/utils";
import type { WorkspaceAccount } from "common/types";

import { MANAGE_ACCOUNTS_ACTIONS } from "../../constants";

import type { JSX } from "react";

export default function DesktopDropdown({
  isOpen,
  setIsOpen,
  action,
  setAction,
  selectedAccounts,
  children,
}: {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  action: keyof typeof MANAGE_ACCOUNTS_ACTIONS;
  setAction: (action: keyof typeof MANAGE_ACCOUNTS_ACTIONS) => void;
  selectedAccounts: WorkspaceAccount[];
  children: JSX.Element;
}) {
  const ActionComponent = action
    ? MANAGE_ACCOUNTS_ACTIONS[action].component
    : undefined;

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>{children}</DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuList>
            {typedObjectEntries(MANAGE_ACCOUNTS_ACTIONS).map(
              ([actionKey, { icon: Icon, label }]) => (
                <DropdownMenuItem
                  key={label}
                  onSelect={() => {
                    setAction(actionKey);
                  }}
                >
                  <Icon weight="fill" />
                  {label}
                </DropdownMenuItem>
              ),
            )}
          </DropdownMenuList>
        </DropdownMenuContent>
      </DropdownMenu>
      <Dialog open={isOpen} onOpenChange={setIsOpen}>
        <DialogContent className={action === "seats" && "lg:w-[448px]"}>
          <ActionComponent
            selectedAccounts={selectedAccounts}
            onBack={() => setIsOpen(false)}
          />
        </DialogContent>
      </Dialog>
    </>
  );
}
